// PartsAdd.jsx
import React from "react";
import "./partsaddtextfield.scss";
import Validation from "../../constants/validation/Validation";
import { useTranslation } from "react-i18next";

const PartsAdd = ({ state, states, handleChange, mode, handlePriceChange, Country_name}) => {
  const { i18n, t } = useTranslation();
  return (
    <div>
      <div className="addparts_textfieldparts">
        <div className="pgmlistdropdown_div">
          <div class="input-wrapper">
            <label className="required" for="search">{t('addpartner.name')}</label>
            <input
              type="text"
              name="name"
              id="name"
              value={mode === "Edit" ? state?.name : states?.name}
              className="input_parts_orders"
              onChange={handleChange}
              rows={10}
              cols={50}
              maxLength={50}
            />
            {mode === "Edit" ?
              <p className='text_count_name_add_parts_page'>{(state?.name)?.length || 0}/50</p>
              : <p className='text_count_name_add_parts_page'>{(states?.name)?.length || 0}/50</p>}
          </div>
        </div>
        <div className="pgmlistdropdown_div">
          <div class="input-wrapper">
            <label className="required" for="search">{t('partlist.partid')}</label>
            <input
              maxLength={20}
              type="text"
              name="part_id"
              id="part_id"
              value={mode === "Edit" ? state?.part_id : states?.part_id}
              onChange={handleChange}
              className="input_parts_orders"
            />
          </div>
        </div>
        <div className="pgmlistdropdown_div">
          <div class="input-wrapper">
            <label className="required" for="search">{t('partlist.price')}</label>
            <input
              type="text"
              name="price"
              id="price"
              disabled={ Country_name?.toLowerCase() === "nigeria" }
              value={mode === "Edit" ? state.currency + " " + state?.price : states?.price}
              onChange={handlePriceChange}
              onKeyPress={(e) => Validation.numberInputWithDecimalValidator(e)}
              className="input_parts_orders"
              maxLength={10}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartsAdd;
